// extracted by mini-css-extract-plugin
export default {"Payments":"Payments_Payments__nMjQk","PaymentList":"Payments_PaymentList__jevl+","PaymentsHeader":"Payments_PaymentsHeader__qe6uv"};